<template>
    <div>
        <header>
            <div v-if="isshowHeader">
                <h4>城市地区选择</h4>
                <h5>省市区选择</h5>
            </div>
        </header>
        <div class="area-title">
            <span :class="{active:curPick(areaType.province)}" @click="loadProvince">{{selectedProvince.name || '请选择'}}</span>
            <span :class="{active:curPick(areaType.city)}" v-if="curPick(areaType.city) || curPick(areaType.country)" @click="loadCity">{{selectedCity.name || '请选择'}}</span>
            <span class="active" v-if="curPick(areaType.country)" @click="loadCountry">{{selectedCountry.name || '请选择'}}</span>
        </div>
        <ul class="area-list" ref="refArea">
            <li v-for="(item, index) in areaList" :key="index" @click="selectArea({item,index})" :class="{active:showTickIcon(index)}">
                <template v-if="item.highlightName">
                    <span v-html="item.highlightName"></span>
                </template>
                <template v-else>{{item.name}}</template>
                <slot name="item-decorator" :active="selectedItmIndex===index" />
            </li>
        </ul>
    </div>
</template>

<script>
import Overlay from './overlay/index'
import {RegionGroup} from '@/constant/common'
import UIP from '@/util/uip.js'
    export default {
        name: 'country-selector',
        props: {
            selectCompleted: {
                type: Boolean,
            },
            areaData: {
                type:Object,
            },
            selectedProvince: {
                type:Object,
            },
            selectedCity: {
                type:Object,
            },
            selectedCountry: {
                type:Object,
            },
            isshowHeader: {
                type: Boolean,
                default: true,
            },
            selectedAreaType: {
                type: String,
            }
        },
        data () {
            return {
                areaType : {
                    province: 'province',
                    city: 'city',
                    country: 'country',
                },
                selectedItmIndex: -1,                           // 选中区域列表项的索引
                prevItmIndex: {                                 // 上次选中区域列表项的索引
                    'province': -1,
                    'city': -1,
                    'country': -1
                },
                hasBack:false,
            }
        },
        computed: {
            areaList () {
                const key = {
                    province: 'provinces',
                    city: 'cities',
                    country: 'countries',
                }[this.selectedAreaType]
                return this.areaData[key]
            },
            curPick () {
                return function(typeName) {
                    return (this.selectedAreaType === this.areaType[typeName])
                }
            },
            showTickIcon () {
                return function(index) {
                    return  (this.selectCompleted || this.hasBack) && index === this.selectedItmIndex
                }
            }
        },
        methods: {
            selectArea ({item, index}) {                                                // 省市区共用列表项
                const callFnName = {
                    province: 'selectProvince',
                    city: 'selectCity',
                    country: 'selectCountry',
                }[this.selectedAreaType]
                item && Reflect.apply(this[callFnName], this, [item])                   // 选择范围，范围类型会改变
                this.prevItmIndex[this.selectedAreaType] = index                        // 记录选择的范围
                this.selectedItmIndex = index
                this.hasBack = false
            },
            selectProvince (val) {
                if (this.areaData.provinces.length<=0) return
                /**
                 * @author 80004302
                 * @desc 若选中省份为当前省份，则清空再选择，触发watcher
                 * @desc 用于选项卡回退后点击当前选中项，加载子级项
                 */
                if (this.selectedProvince.name === val.name) {
                    this.$emit('update:selectedProvince', {})
                    this.$emit('update:selectedProvince', val)
                }
                this.$emit('update:selectedProvince', val)                              // 选中省份
            },
            selectCity (val) {
                if (this.areaData.cities.length<=0) return
                                /**
                 * @author 80004302
                 * @desc 若选中省份为当前省份，则清空再选择，触发watcher
                 * @desc 用于选项卡回退后点击当前选中项，加载子级项
                 */
                if (this.selectedCity.name === val.name) {
                    this.$emit('update:selectedCity', {})
                    this.$emit('update:selectedCity', val)
                }
                this.$emit('update:selectedCity', val)
            },
            selectCountry (val) {
                if (this.areaData.countries.length<=0) return
                this.$emit('update:selectedCountry', val)
                if(!this.selectCompleted) {
                    this.$emit('update:selectCompleted', true)
                }
            },
            loadProvince () {
                if(this.selectCompleted) {
                    this.$emit('update:selectCompleted', false)
                }
                this.$emit('update:selectedAreaType', 'province')
                this.$emit('update:selectedProvince', {})
                this.$emit('update:selectedCity', {})
                this.$emit('update:selectedCountry', {})
                this.selectedItmIndex = this.prevItmIndex.province
                if (this.prevItmIndex.province > -1) {
                    this.scrollToPrevPos(this.prevItmIndex.province)
                } else {
                    this.selectedItmIndex = -1
                }
                this.hasBack = true
            },
            loadCity () {
                if (this.selectCompleted) {
                    this.$emit('update:selectCompleted', false)
                }
                this.$emit('update:selectedAreaType', 'city')
                this.$emit('update:selectedCity', {})
                this.$emit('update:selectedCountry', {})
                this.selectedItmIndex = this.prevItmIndex.city
                if (this.prevItmIndex.city > -1) {
                    this.scrollToPrevPos(this.prevItmIndex.city)
                } else {
                    this.selectedItmIndex = -1
                }
                this.hasBack = true
            },
			loadCountry () {
				if (this.selectCompleted) {
					this.$emit('update:selectCompleted', false)
				}
				this.$emit('update:selectedAreaType', 'country')
				this.$emit('update:selectedCountry', {})
				this.selectedItmIndex = this.prevItmIndex.country
				if (this.prevItmIndex.country > -1) {
					this.scrollToPrevPos(this.prevItmIndex.country)
				} else {
					this.selectedItmIndex = -1
				}
				this.hasBack = true
			},
            scrollToPrevPos (index) {
                this.$nextTick( function() {
                    let el = this.$refs.refArea
                    if(!el) return
                    try {
                        let liHeight = (el.firstElementChild||{}).offsetHeight
                        el.scrollTop = parseInt(liHeight * index)
                    }catch(e) {
                        console.log(e)
                    }
                })
            },
            init () {
                if(this.selectedCountry) {
                    let idx = -1
                    if (this.selectedCountry.name) {
                        idx = this.areaData.countries.findIndex(item => item.name === this.selectedCountry.name)
                    } else if (this.selectedCity.name) {
                        idx = this.areaData.cities.findIndex(item => item.name === this.selectedCity.name)
                    }
                    this.selectedItmIndex = idx
                    this.scrollToPrevPos(idx)
                    if (this.selectedItmIndex > -1) {
                        this.$emit('update:selectCompleted', true)
                    } else {
                        this.$emit('update:selectCompleted', false)
                    }
                }
            }
        },
        watch: {
            /**
             * 解决重新进入页面props数据没更新，没选中状态
            */
            selectedCountry (val) {
                val && this.init()
            },
            /**
             * 澳门只有二级行政区，需要重新监听城市的选择
            */
            selectedCity (val) {
                val && UIP.utils.check.AREA.isMO(this.selectedProvince.rateCode) && this.init()
            }
        },
        async created () {
            await this.init()
        },
        components: {
            Overlay,
        }
    }
</script>

<style lang="scss" scoped>
    h4 {
        text-indent: .5rem;
        padding: .3rem;
        font-weight: 800;
        border-bottom: solid 1px #efefef;
    }
    h5 {
        color: #ccc;
        padding-top: .2rem;
        text-indent: 2ch;
    }
    .area-title {
        height: 1rem;
        line-height: 1rem;
        font-weight: 800;
        border-bottom: solid 1px #efefef;
        white-space:nowrap;
        padding-left: .6rem;
        >>>span {
            display: inline-block;
            margin-right: .8rem;
            width: 6ch;
            text-overflow: ellipsis;
            overflow: hidden;
            position: relative;
            flex: 1;
            &.active {
                color: rgba(226, 12, 12, 0.842);
                &::after {
                    content: '';
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    width:100%;
                    height: .05rem;
                    background:rgba(226, 12, 12, 0.842);
                    border-radius:.1rem;
                }
            }
        }
    }
    .area-list {
        flex: 1;
        height: 6rem;
        line-height: 1rem;
        overflow-y: auto;
        overflow-x: hidden;
        li {
            padding: 0 .3rem;
            &:nth-child(odd) {
                background: #fcfcfc;
            }
            &.active {
                color:rgba(226, 12, 12, 0.842);
                &::before {
                    content: '\2714';
                    position: relative;
                    float: right;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/citySelector/index.vue